import { isArray } from "lodash";

export default function formatFieldError({ submitError, syncError }) {
  const errors = submitError || syncError;
  if (!errors) {
    return null;
  }
  return isArray(errors) ? errors : [errors];
}
